const initImageVideoGallery = () => {
    const config = new CarouselConfig();
    config.sliderSelector = "[data-image-video-gallery-carousel]";
    config.cellAlign = CellAlign.center;
    config.contain = true;
    config.autoPlay = false;
    config.wrapAround = false;
    config.showArrows = true;
    config.showDots = false;
    config.groupCells = true;
    config.adaptiveHeight = true;
    config.imagesLoaded = true;
    config.arrowShape = "M0.660953 23.5214L23.3877 0.794447C24.2041 -0.158856 25.6388 -0.269987 26.5921 0.5466C27.5454 1.36299 27.6566 2.79773 26.84 3.75103C26.7638 3.8399 26.681 3.92291 26.5921 3.99888L7.75165 22.8622H97.7274C98.9824 22.8622 100 23.8798 100 25.135C100 26.3903 98.9824 27.4076 97.7274 27.4076H7.75165L26.5921 46.2481C27.5454 47.0645 27.6566 48.4993 26.84 49.4526C26.0234 50.4059 24.5888 50.517 23.6355 49.7004C23.5467 49.6242 23.4637 49.5414 23.3877 49.4526L0.660757 26.7256C-0.220282 25.8395 -0.220281 24.4079 0.660953 23.5214Z";
    const responsiveCarousel = new ResponsiveCarousel();
    responsiveCarousel.initCarousel(config);
};
const initRetriveYTPreview = () => {
    const imageVideoGalleryWidgetList = document.querySelectorAll("[data-image-video-gallery-widget]");
    if (imageVideoGalleryWidgetList && imageVideoGalleryWidgetList.length > 0) {
        imageVideoGalleryWidgetList.forEach((imageVideoGalleryWidget) => {
            const videoImgContainerList = imageVideoGalleryWidget.querySelectorAll("[data-video-img-bg]");
            if (videoImgContainerList && videoImgContainerList.length > 0) {
                videoImgContainerList.forEach((videoImgContainer) => {
                    const img = videoImgContainer.querySelector("[data-img]");
                    let ytLink;
                    if (videoImgContainer.getAttribute("href").includes("/embed/")) {
                        ytLink = videoImgContainer.getAttribute("href").split("/").pop();
                    }
                    else if (videoImgContainer.getAttribute("href").includes("/watch?v=")) {
                        ytLink = videoImgContainer.getAttribute("href").split("v=").pop();
                    }
                    else {
                        console.log("Incorrect Link");
                        return;
                    }
                    img === null || img === void 0 ? void 0 : img.setAttribute("src", `https://i.ytimg.com/vi/${ytLink}/0.jpg`);
                });
            }
        });
    }
};
